export type AppRole = 'blueprint:super_admin' | 'blueprint:admin' | 'blueprint:srblueprint' | 'blueprint:blueprint' | 'blueprint:srdesigner' | 'blueprint:designer' | 'blueprint:user';

export const hasRole = (roles: Array<string> | null | undefined, role: string | Array<string>): boolean => {
	if (!roles || roles.length === 0) return false;
	if (Array.isArray(role)) return role.some((r) => roles.includes(r));
	return roles.includes(role);
};
